(function(){
  var mq, desc, media, origParent, origNext, styled=false;
  function ensureStyle(){
    if(styled) return; styled=true;
    var s=document.createElement('style');
    s.textContent='@media(min-width:750px){.product__media-wrapper .pono-desc-media{margin-top:2.4rem;padding-top:1.6rem;border-top:1px solid rgba(var(--color-foreground),.12);} .product__media-wrapper .pono-desc-media>*:first-child{margin-top:0;}}';
    document.head.appendChild(s);
  }
  function place(){
    desc=document.querySelector('.product__info-wrapper .product__description')||document.querySelector('.product__description');
    media=document.querySelector('.product__media-wrapper');
    if(!desc||!media) return;
    if(!origParent){ origParent=desc.parentNode; origNext=desc.nextElementSibling; }
    if(mq.matches){
      if(desc.parentNode!==media){ media.appendChild(desc); desc.classList.add('pono-desc-media'); }
    } else {
      if(desc.parentNode===media){ if(origNext && origNext.parentNode===origParent){ origParent.insertBefore(desc,origNext); } else { origParent.appendChild(desc); } desc.classList.remove('pono-desc-media'); }
    }
  }
  function boot(){
    if(!document.querySelector('.product__media-wrapper')) return;
    ensureStyle();
    mq=window.matchMedia('(min-width:750px)');
    setTimeout(place,300); setTimeout(place,1000);
    if(mq.addEventListener) mq.addEventListener('change',place); else if(mq.addListener) mq.addListener(place);
    var t; window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(place,150); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
